import { FeasibilityMap } from "../FeasibilityMap";
import { HoursOfServiceTable } from "../HoursOfServiceTable";
import { Button, CityState, DataSource, Image, Label, Layout, Panel, Repeater, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFeasibility extends Layout {
    buttonEquipManageAssign: Button;
    citystateDelivery: CityState;
    citystateFinalStop: CityState;
    citystateLastCleared: CityState;
    citystatePickup: CityState;
    imageChecklistStatusError: Image;
    imageDeliveryApptReq: Image;
    imageFinalApptReq: Image;
    imageMoveStatus: Image;
    imagePickupApptReq: Image;
    imageSelectedImage: Image;
    imageValidImage: Image;
    imageWarningImage: Image;
    labelActivitiesHeader: Label;
    labelCurrentDispatchOrder: Label;
    labelCurrentDispatchTitle: Label;
    labelDeliveryCaption: Label;
    labelDeliveryEarly: Label;
    labelDeliveryLate: Label;
    labelDistToPickupCaption: Label;
    labelDistanceToPickup: Label;
    labelDriverInfoCaption: Label;
    labelErrorCount: Label;
    labelFinalStopArriveLate: Label;
    labelHosTitle: Label;
    labelLastClearedActualDeparture: Label;
    labelLastMCPosCaption: Label;
    labelLastMcPosition: Label;
    labelPickupCaption: Label;
    labelPickupEarly: Label;
    labelPickupLate: Label;
    labelSelectedOrder: Label;
    labelSelectedOrderTitle: Label;
    labelTimezone: Label;
    labelValidCount: Label;
    labelWarningCount: Label;
    layoutFeasibilityMap: FeasibilityMap;
    layoutHoursOfServiceTable: HoursOfServiceTable;
    panelActivites: Panel;
    panelChecklist: Panel;
    panelChecklistStatus: Panel;
    panelCurrentDispatch: Panel;
    panelCurrentDispatchComponents: Panel;
    panelCurrentStops: Panel;
    panelDelivery: Panel;
    panelDriverInfo: Panel;
    panelError: Panel;
    panelFeasibilityInfo: Panel;
    panelFinalStop: Panel;
    panelFinalStopDates: Panel;
    panelHosComponents: Panel;
    panelHosSumInfo1: Panel;
    panelHosSumInfo2: Panel;
    panelHoursOfService: Panel;
    panelHoursOfServiceSummary: Panel;
    panelLastClearedStop: Panel;
    panelPickup: Panel;
    panelScheduledDeliveryDates: Panel;
    panelScheduledPickupDates: Panel;
    panelSelectedBottomSection: Panel;
    panelSelectedOrder: Panel;
    panelSelectedOrderComponents: Panel;
    panelSelectedTopSection: Panel;
    panelSummary: Panel;
    panelValid: Panel;
    panelWarning: Panel;
    repeaterTimeline: Repeater;
    sourceDriverInfo: DataSource;
    sourceFeasibility: DataSource;
    tabChecklist: Tab;
    tabHoursOfService: Tab;
    tabList: Tab;
    tabMap: Tab;
    tabTimeline: Tab;
    tableChecklist: Table;
    tableList: Table;
    tabsetActivities: Tabset;
    tabsetChecklist: Tabset;
    tabsetHoursOfService: Tabset;
    textboxAvlDriveHours: Textbox;
    textboxAvlOndutyHours: Textbox;
    textboxDriverName: Textbox;
    textboxDutyStatus: Textbox;
    textboxEmptyFuelDist: Textbox;
    textboxEstimatedDriveTime: Textbox;
    textboxFinalStopArriveEarly: Textbox;
    textboxLastClearedActualArrival: Textbox;
    textboxLoadedFuelDist: Textbox;
    textboxPTA: Textbox;
    textboxTotalDist: Textbox;
}
